import { breakpoints, colors, getTypography, pxToRem } from '@vfit/shared/themes';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: fit-content;
  width: 100%;
  border: none;
  border-radius: ${pxToRem(6)};
  padding: ${pxToRem(20, 16)};
  gap: ${pxToRem(16)};
  box-shadow: 0 2px 8px rgb(0 0 0 / 0.16);
  background-color: ${colors.$ffffff};

  @media (min-width: ${breakpoints.tablet}) {
    padding: ${pxToRem(24, 16)};
  }

  @media (min-width: ${breakpoints.desktop}) {
    padding: ${pxToRem(32, 16)};
  }
`;

export const Title = styled.h2<{
  fontSize?: { mobile?: string; tablet?: string; desktop?: string };
  color?: string;
}>`
  margin: 0;
  ${getTypography('h5.bold')}
  font-size:  ${({ fontSize }) => fontSize?.mobile || pxToRem(24)};
  color: ${({ color }) => color || colors?.$333333};

  @media (min-width: ${breakpoints.tablet}) {
    font-size: ${({ fontSize }) => fontSize?.tablet || pxToRem(24)};
  }

  @media (min-width: ${breakpoints.desktop}) {
    font-size: ${({ fontSize }) => fontSize?.desktop || pxToRem(28)};
  }

  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }

  ul {
    margin: 0;
    margin-block: 0;
    padding-inline: ${pxToRem(25)};
  }
`;

export const Text = styled.article<{
  fontSize?: { mobile?: string; tablet?: string; desktop?: string };
  color?: string;
}>`
  margin: 0;
  ${getTypography('body1.regular')}
  font-size:  ${({ fontSize }) => fontSize?.mobile || pxToRem(18)};
  color: ${({ color }) => color || colors?.$333333};

  @media (min-width: ${breakpoints.tablet}) {
    font-size: ${({ fontSize }) => fontSize?.tablet || pxToRem(18)};
  }

  @media (min-width: ${breakpoints.desktop}) {
    font-size: ${({ fontSize }) => fontSize?.desktop || pxToRem(18)};
  }

  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }

  ul {
    margin: 0;
    margin-block: 0;
    padding-inline: ${pxToRem(25)};
  }
`;
